<template>
     <div>
        <!-- 下拉选择弹框组建封装 开始 -->
         <transition name="ryt-transition">
            <div :class="['pop-selector', { 'container-dark': theme_dark }]" v-show="currentValue" >
                    <p class="title">{{title}}</p>
                    <ul>
                        <li class="ub ub-ac" @click="clickItem(item,index)" v-for="(item,index) in actions" :key="index">{{item}}</li>
                    </ul>
                    <div class="ub ub-pc ub-ac">
                    <button class="cancel ub ub-pc ub-ac" @click="closeRytDropdown" :style="{color:cancenTextColor}">{{cancelText}}</button>
                    </div>
                </div>
             </transition>

        <!-- 下拉选择弹框组建封装 结束 -->
        </div>
</template>

<script>
import * as tool from '../api/common';
    export default {
        name: "rytDropdown",
        props: {
            title: {
                type: String,
                default: '请选择您将进行的操作'
            },
            actions: {
                type: [Array, String, Object], //传过来的参数可以为对象，字符串，数组
                default: () => []
            },
            cancelText: {
                type: String,
                default: '取消'
            },
            center: { //接受父组件给子组件的center属性的传值
                type: Boolean,
                default: false
            },
            cancenTextColor: {  //取消按钮的文字颜色
                type: String,
                default: 'rgb(255, 130, 0)'
            }

        },
        data() {
            return {
                currentValue: false,
                theme_dark: false
            }

        },
        methods: {
            closeRytDropdown() { //关闭子组件
                this.currentValue = false
            },
            clickItem(item, index) { //选择下拉框选项
                this.$emit('clickOption', {
                    item: item,
                    index: index
                })

                this.currentValue = false
            }
        },
        watch: {
            currentValue(val) { //监听currentValue的值传给父组件，父组件没有Input事件为什么还传值给父组件了？解释： v-model 绑定的是input事件
                this.$emit('input', val);
            },
            center(val) { //监听父组件通过props传过来的center的布尔值打开子组件下拉框
                this.currentValue = val
            }

        },
        mounted() {
            //切换深色模式
            this.theme_dark = tool.is_theme_dark(this);
        },

    }
</script>
<style lang="scss" scoped>
    .pop-selector {
        position: fixed;
        width: 100%;
        text-align: center;
        bottom: 0;
        left: 50%;
        max-height: 100%;
        border-top-left-radius: 2rem;
        border-top-right-radius: 2rem;
        background: linear-gradient( 180deg, #e4d2f3, #FFFFFF);
        overflow-y: auto;
        transform: translate3d(-50%, 0, 0);
        backface-visibility: hidden;
        transition: transform .3s ease-out;
        overflow: hidden;
        padding-top: 1rem;
        .title {
            color: #6C1AAB;
            font-size: 1rem;
            height: 3rem;
            line-height: 3rem;
            padding: 0;
            margin: 0;
            position: relative;
            font-weight: bold;
            border-bottom:  1px solid #cccccc;
        }

        ul li {
            padding: 0.5rem;
            height: 2.5rem;
            line-height: 2.5rem;
            font-size: 1rem;
            color: #333;
            border-bottom: 1px solid #DCDCDC;
        }
        .cancel {
            height: 2.5rem;
            line-height: 2.5rem;
            padding: 0 1rem;
            margin: 1rem 0;
            font-size: 1rem;
            color: #333;
            border: none;
            border-radius: 2rem;
            background: linear-gradient( 90deg, #A264E7, #FE9CC0);
        }
    }

    .container-dark {
        background: linear-gradient( 180deg, #666, #333);
        .title {
            color: #fff;
            border-bottom: 1px solid #666;
        }
        ul li {
            color: #DFDFDF;
            border-bottom: 1px solid #666;
        }
    }

/*弹窗动画*/
.ryt-transition-enter,
.ryt-transition-leave-active {
    transform: translate3d(-50%, 100%, 0);
    transition: transform 0.6s ease-in-out;
}    
</style>
